import React, { FC, useCallback, MouseEvent } from 'react';
import s from './ThumbnailButton.scss';

type Props = {
  Icon: FC<React.SVGAttributes<SVGElement>>;
  onClick?(): void;
  iconSize?: number;
  text?: string;
};

export const ThumbnailButton: FC<Props> = ({
  Icon,
  onClick,
  iconSize = 40,
  text,
}) => {
  const handleClick = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      if (onClick) {
        onClick();
      }

      // ThumbnailButton is the child of Thumbnail's overlay.
      // Overlay has it's own onClick (video selecting only).
      // Prevent triggering both handlers
      event.stopPropagation();
    },
    [onClick],
  );

  return (
    <button className={s.root} onClick={handleClick}>
      <Icon width={`${iconSize}px`} height={`${iconSize}px`} />
      {text && <span>{text}</span>}
    </button>
  );
};
